import { Select } from 'antd'
import React from 'react'
import { GROUPS } from '../../API/url'
import Styles from './SelectStyles.module.css';

export default function SelectComp({size, options, onChangeFunc, width, val, isString=true ,labelInValue,placeholder="placeholder...",defaultValue}) {
  
  return (
    <>
    <Select   defaultValue={{defaultValue}}  popupClassName={Styles.selectCss} labelInValue={labelInValue} value={isString?parseInt(val):val} placeholder={placeholder} onChange={(e)=>onChangeFunc(e)} options={options} style={{width:width,border:'none', boxShadow:'0px 1px 2px 0px #1018280D',fontSize:'16px'}} size={size} />
    </>
  )
}
